// extracted by mini-css-extract-plugin
export default {"container":"WY-z","title":"XY-z","link":"YY-z"};